import { render } from "./osszesMegrendeles.vue?vue&type=template&id=6d180549&scoped=true"
import script from "./osszesMegrendeles.vue?vue&type=script&lang=js"
export * from "./osszesMegrendeles.vue?vue&type=script&lang=js"

import "./osszesMegrendeles.vue?vue&type=style&index=0&id=6d180549&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d180549"]])

export default __exports__